import React from 'react';
import PropTypes from 'prop-types';
import { Type } from '@nerdwallet/currency';
import LoadingN from '@nerdwallet/react-loading-n';

const CCCardArt = ({ product, suppressRedirect }) => {
  return (
    <div className="cc-card-art-container">
      <div className="cc-card-art-design">
        <LoadingN className="cc-card-art-nw-logo" size={60} />
        <div className="cc-card-art-dots">
          <div className="cc-card-art-ellipse" />
          <div className="cc-card-art-ellipse" />
          <div className="cc-card-art-ellipse" />
        </div>
        <img className="cc-card-art-image" src={product.imageSource} alt="" />
      </div>
      <Type className="cc-card-art-text" size="2-half">
        Hang tight! We&apos;re redirecting you to {product.institutionName}
        &apos;s Website.
      </Type>
      {suppressRedirect && <Type>Redirect suppressed.</Type>}
    </div>
  );
};

CCCardArt.propTypes = {
  product: PropTypes.shape({
    imageSource: PropTypes.string,
    institutionName: PropTypes.string,
  }),
  suppressRedirect: PropTypes.bool,
};

export default CCCardArt;
